/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ProcessListPage = lazyLoad(
  () => import('./index'),
  module => module.ProcessListPage
);
